// Constants
/**
 * Helper function to get the store table name for a slice main item status table
 * @param name The name of the slice
 */ export function status(name) {
    return `${name}-status`;
}
/**
 * Helper function to get the store table name for the slice collection status table
 * @param name The name of the data slice
 * @param collectionName The name of the collection
 */ export function collection(name, collectionName) {
    return `${name}-${collectionName}-status`;
}
